<template>
  <l-fixed-window>
    <v-tabs grow slot="fixed-top" v-model="tabs">
      <v-tab href="#common">通用配置</v-tab>
      <v-tab href="#orgConfig">单位配置</v-tab>
    </v-tabs>
    <div>
      <v-tabs-items v-model="tabs">
        <v-tab-item :value="'common'">
          <common-Config :order-type-prop="'order_group'" :status-prop="'readonly'" :owner-type-prop="'common'"></common-Config>
        </v-tab-item>
        <v-tab-item :value="'orgConfig'">
          <org-config-list :order-type="'order_group'"></org-config-list>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </l-fixed-window>
</template>

<script>
import commonConfig from '../Common/commonConfig'
import orgConfigList from '../Common/orgConfigList'
export default {
  name: 'OrgReservationConfig',
  components: {
    commonConfig, orgConfigList
  },
  data () {
    return {
      tabs: null
    }
  }
}
</script>

<style scoped>

</style>
